import React from "react";
import Vitals from "./Vitals";
import DiagnosisTable from "./DiagnosisTable";
import Graphview from "./Graphview";
const Main = ({ selectedPatient }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        backgroundColor: "#ffff",
        height: "auto",
        borderRadius: "10px",
        padding: "15px",
        rowGap: "20px",
        boxSizing:"border-box"
      }}
    >
      <Graphview selectedPatient={selectedPatient} />
      <Vitals selectedPatient={selectedPatient} />
      <DiagnosisTable selectedPatient={selectedPatient} />
    </div>
  );
};

export default Main;
